import React, { useEffect } from 'react';
import { 
  FaShip, FaTools, FaUserCog, FaPeopleCarry, FaHardHat, FaTint, FaOilCan, FaBookOpen, 
  FaShieldAlt, FaClipboardCheck, FaShippingFast, FaAnchor, FaWrench
} from 'react-icons/fa';
import anime from 'animejs';

function Services() {
  const servicesData = [
    { icon: <FaShip />, desc: "Professional Agency Services at Turkish Straits and all Ports" },
    { icon: <FaTools />, desc: "All kind of repairs & agency services at Tuzla & Yalova Shipyards" },
    { icon: <FaUserCog />, desc: "Fresh Provisions, Deck and Engine Stores, Technical materials, repairs" },
    { icon: <FaPeopleCarry />, desc: "Crew Changes & Inspectors + Superintendent Attendances at all Ports" },
    { icon: <FaHardHat />, desc: "Slops and Sludge Disposals at Canakkale / Istanbul roads w/out delays" },
    { icon: <FaTint />, desc: "Urgent Assistance for Underwater Jobs, video with Class attendances" },
    { icon: <FaOilCan />, desc: "Bunkering, Fresh Water and Lubricants Supply" },
    { icon: <FaBookOpen />, desc: "Cargo Sampling & Pre-loading + Loading and any kind of Survey Jobs." },
    { icon: <FaShieldAlt />, desc: "Spare Parts Clearance from Customs & Deliveries – Land of samples etc." },
    { icon: <FaClipboardCheck />, desc: "Cash Deliveries at All Turkish Ports / Istanbul and Canakkale straits." },
    { icon: <FaShippingFast />, desc: "Class and P&I Attendances" },
  ];

  useEffect(() => {
    const tl = anime.timeline({ easing: 'easeOutExpo' });

    tl.add({
      targets: '.header-reveal',
      opacity: [0, 1],
      translateY: [40, 0],
      duration: 1000,
    })
    .add({
      targets: '.service-card',
      opacity: [0, 1],
      translateY: [25, 0],
      scale: [0.98, 1],
      delay: anime.stagger(70, { start: 150 }), 
      duration: 750
    }, '-=650'); 
  }, []);

  return (
    <div className="bg-[#fdfcfb] min-h-screen font-sans selection:bg-[#c4a47c] selection:text-white">
      
      {/* Header Bölümü */}
      <section className="relative py-32 md:py-40 bg-[#0a111f] overflow-hidden">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-500/5 rounded-full blur-[120px] pointer-events-none"></div>
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#c4a47c]/5 rounded-full blur-[100px] pointer-events-none"></div>
        
        <div className="absolute inset-0 opacity-[0.03] flex items-center justify-center pointer-events-none">
          <FaWrench size={200} className="text-white -rotate-12 translate-y-10" />
        </div>
        
        <div className="max-w-7xl mx-auto px-8 relative z-10 text-center header-reveal">
          <div className="flex items-center justify-center space-x-3 mb-8">
            <div className="h-[1px] w-12 bg-[#c4a47c]"></div>
            <FaAnchor className="text-[#c4a47c] text-sm" />
            <div className="h-[1px] w-12 bg-[#c4a47c]"></div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white uppercase italic tracking-tighter leading-none mb-6">
            Our <span className="text-[#c4a47c]">Services</span>
          </h1>
        </div>
      </section>

      {/* Kartlar Bölümü */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 -mt-16 relative z-20 pb-40">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => (
            <article 
              key={index} 
              className="service-card group relative p-10 rounded-[3.5rem] bg-white border border-white shadow-[0_20px_50px_rgba(0,0,0,0.03)] hover:shadow-[0_50px_100px_rgba(196,164,124,0.15)] hover:border-[#c4a47c]/30 hover:-translate-y-3 transition-all duration-700 overflow-hidden"
            >
             
              <span className="absolute top-6 right-8 text-7xl font-black text-slate-100 group-hover:text-[#c4a47c]/10 transition-all duration-700 select-none pointer-events-none italic tracking-tighter">
                {index + 1 < 10 ? `0${index + 1}` : index + 1}
              </span>

              <div className="relative z-10">
     
                <div className="w-20 h-20 rounded-[2rem] bg-[#fcf9f3] flex items-center justify-center mb-10 text-[#c4a47c] text-4xl group-hover:bg-[#0a111f] group-hover:text-white transition-all duration-500 shadow-inner group-hover:shadow-xl group-hover:rotate-6">
                  {service.icon}
                </div>
                
                <p className="text-[#0a111f] font-black text-[15px] md:text-[17px] uppercase tracking-tight leading-relaxed pr-4 group-hover:text-[#c4a47c] transition-colors duration-500">
                  {service.desc}
                </p>
              </div>

              <div className="absolute bottom-0 left-0 h-1.5 bg-[#c4a47c] w-0 group-hover:w-full transition-all duration-1000 ease-in-out"></div>
            </article>
          ))}
        </div>
      </div>

      <div className="h-2 bg-gradient-to-r from-[#0a111f] via-[#c4a47c] to-[#0a111f]"></div>
    </div>
  );
}

export default Services;